import {
  TextField,
  Box,
  Chip,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Stack,
  Typography,
  Link,
} from "@mui/material";
import React, { useState } from "react";
import ConfirmationWithDescription from "src/components/ConfirmationWithDescription";
import {
  _get_user_from_localStorage,
  _get_user_from_localStorage_new,
} from "src/DAL/localStorage/localStorage";
import { getValidMealArray } from "src/utils/constants";
import { Link as RouterLink } from "react-router-dom";
import DescriptionSeeMore from "./DescriptionSeeMore";

const FoodMattersAndMindsetUI = ({
  addArray,
  setaddArray,
  setModalChangeExe,
  mainindex,
  isWorkoutCompleted,
  setIsWorkoutCompleted,
  practiceType,
  handleSubmit,
  meals_data,
}) => {
  const [openExerciseAlert, setOpenExerciseAlert] = useState(false);
  const [exerIndex, setExerIndex] = useState("");

  const handleChangeComplete = (e, index) => {
    const { checked } = e.target;
    const list = [...addArray];
    if (!checked && isWorkoutCompleted) {
      setExerIndex(index);
      setOpenExerciseAlert(true);
      return;
    }
    list[index]["is_completed"] = checked;

    setModalChangeExe(true);
    setaddArray(list);
    if (checked) {
      handleSubmit(true, true);
    }
  };

  const handleAgreeInExerciseSet = () => {
    const list = [...addArray];
    list[exerIndex]["is_completed"] = false;
    setIsWorkoutCompleted(false);
    setModalChangeExe(true);
    setOpenExerciseAlert(false);
    setaddArray(list);
  };

  const handleChangeDes = (e, index) => {
    const { name, value } = e.target;

    const list = [...addArray];
    list[index][name] = value;

    setaddArray(list);
    setModalChangeExe(true);
  };

  let total_kacl = 0;

  let user_info = _get_user_from_localStorage_new();

  if (
    user_info?.regular_day_calories &&
    meals_data?.editData?.target_day == "regular"
  ) {
    total_kacl = user_info?.regular_day_calories;
  } else if (
    user_info?.high_day_calories &&
    meals_data?.editData?.target_day == "high"
  ) {
    total_kacl = user_info?.high_day_calories;
  } else if (
    user_info?.low_day_calories &&
    meals_data?.editData?.target_day == "low"
  ) {
    total_kacl = user_info?.low_day_calories;
  }

  const getTotalNutrient = (meals, nutrient, type) => {
    if (!meals && !Array.isArray(meals)) return "0.00";

    return meals
      .reduce((total, meal) => {
        if (!Array.isArray(meal[type])) return total;
        return (
          total +
          meal[type].reduce((mealTotal, food) => {
            const value = food?.measurement_units?.[nutrient] || 0;
            const quantity = parseFloat(food?.quantity) || 0;
            return mealTotal + value * (quantity / 100);
          }, 0)
        );
      }, 0)
      .toFixed(2);
  };

  const getTotalCalories = (meals, type) => {
    const totalCarbs = parseFloat(getTotalNutrient(meals, "carb", type));
    const totalProtein = parseFloat(getTotalNutrient(meals, "protein", type));
    const totalFat = parseFloat(getTotalNutrient(meals, "fat", type));

    return (totalCarbs * 4 + totalProtein * 4 + totalFat * 9).toFixed(2);
  };

  let mealsData = getValidMealArray(meals_data?.editData?.meals);

  // Portions follow the member's current Regular Day calories: every food is scaled so the meal
  // plan adds up to them (a meal without calories is shown as saved).
  const getQuantity = (qun, type) => {
    let quantity = 0;
    const mealCalories = parseFloat(getTotalCalories(mealsData, type));
    if (user_info?.regular_day_calories && mealCalories > 0) {
      quantity = (user_info?.regular_day_calories / mealCalories) * qun;
    } else {
      return qun;
    }
    return quantity.toFixed(2);
  };

  // Programme meals and meals put on the member's own calendar alike: a meal saved for older
  // calories (e.g. before the coach changed the activity level) is rescaled to today's calories,
  // so Goal Calories and portions update straight away.
  if (user_info?.regular_day_calories) {
    if (mealsData && mealsData.length > 0) {
      let data = mealsData.map((meal) => {
        return {
          ...meal,
          meal_food_array:
            meal?.meal_food_array &&
            meal?.meal_food_array.length > 0 &&
            meal?.meal_food_array?.map((unit) => {
              return {
                ...unit,
                quantity: getQuantity(unit.quantity, "meal_food_array"),
              };
            }),
          meal_food_array_alt:
            meal?.meal_food_array_alt &&
            meal?.meal_food_array_alt.length > 0 &&
            meal?.meal_food_array_alt?.map((unit) => {
              return {
                ...unit,
                quantity: getQuantity(unit.quantity, "meal_food_array_alt"),
              };
            }),
        };
      });
      mealsData = data;
    }
  }

  const getQuantityPercentage = (qun) => {
    let quantity = 0;
    if (user_info?.deficit_value && user_info?.deficit_percentage) {
      let deficitPercentage = user_info?.deficit_value / 100;
      quantity = qun * (1 - deficitPercentage);
      return Number(quantity).toFixed(2);
    } else {
      return qun;
    }
  };

  const applyDeficit = () => {
    if (user_info?.deficit_value && user_info?.deficit_percentage) {
      let new_calories =
        getTotalCalories(mealsData, "meal_food_array") *
        (1 - user_info?.deficit_value / 100);
      return new_calories.toFixed(2);
    }
  };

  console.info(meals_data);

  return (
    <div className="my-2">
      <ConfirmationWithDescription
        open={openExerciseAlert}
        setOpen={setOpenExerciseAlert}
        title={"Are you sure you want to take this action?"}
        descriotion={`If you uncheck, your points or coins allocated for this ${practiceType} will be deducted.`}
        handleAgree={handleAgreeInExerciseSet}
        isJustForOk={false}
      />

      <div className="characters mt-2">
        <form onSubmit={() => {}}>
          <div
            style={{
              width: "100%",
              padding: "1px",
              position: "relative",
            }}
          >
            <div
              className="d-flex my-1 workout-set-card w-100"
              style={{
                width: "100%",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                }}
              >
                <div className="row">
                  <div
                    className={`col-sm-12 ${"col-md-7"} col-lg-6 d-flex align-items-center`}
                  >
                    {addArray[mainindex]?.is_modified && (
                      <span
                        style={{
                          position: "absolute",
                          top: "-11px",
                          justifyContent: "center",
                          zIndex: "1",
                          left: "-38px",
                          transform: "rotate(-53deg)",
                        }}
                      >
                        <Chip
                          label={"Modified"}
                          variant="contained"
                          color={"error"}
                          sx={{
                            fontSize: "10px",
                            height: "auto",
                            width: "auto",
                          }}
                        />
                      </span>
                    )}
                    {practiceType === "comment" ? (
                      <TextField
                        id="comment-text"
                        label="Write your comment here"
                        placeholder="Write your comment here"
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={6}
                        name="comment"
                        value={meals_data?.editData?.comment}
                        readOnly
                      />
                    ) : (
                      <TextField
                        id="outlined-basic"
                        variant="outlined"
                        placeholder="Name"
                        value={
                          addArray[mainindex]?.title
                            ? addArray[mainindex]?.title
                            : ""
                        }
                        name="title"
                        multiline
                        rows={addArray[mainindex]?.title ? null : 1}
                        onChange={(e) => handleChangeDes(e, mainindex)}
                        InputLabelProps={{
                          className: "textfiels-input-label",
                          shrink: true,
                          style: { fontSize: "14px" },
                        }}
                        label="Name"
                        InputProps={{
                          className: "textfiels-input-value",
                          style: {
                            fontSize: "13px",
                            paddingLeft: "6px",
                          },

                          inputProps: {
                            readOnly: true,
                          },
                        }}
                        sx={{
                          borderRadius: "5px",

                          fontSize: "13px",
                          width: "100%",
                        }}
                      />
                    )}
                  </div>
                  {practiceType == "food" &&
                    mealsData &&
                    mealsData?.length > 0 && (
                      <>
                        {!user_info?.regular_day_calories ? (
                          <div className="col-12 mt-3">
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems="center"
                              justifyContent="start"
                            >
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  opacity: 0.6,
                                  fontWeight: "600",
                                  fontSize: "12px",
                                }}
                              >
                                Please{" "}
                                <Link
                                  component={RouterLink}
                                  variant="subtitle2"
                                  to={`/edit-profile`}
                                >
                                  Click here
                                </Link>{" "}
                                to enter your details (Gender, Weight, Height,
                                Age, and Activity) to calculate your Regular Day
                                calorie needs for food portioning.
                              </Typography>
                            </Stack>
                          </div>
                        ) : (
                          <>
                            <div className="col-12 mt-3 d-flex justify-content-between">
                              <h3 className="primary_color">Your Meal</h3>
                              <p className="mb-1 d-flex align-items-center justify-content-end">
                                <span className="fw-bold me-3">
                                  Total Calories:&nbsp;
                                </span>
                                {getTotalCalories(mealsData, "meal_food_array")}{" "}
                                kcal
                              </p>
                            </div>
                            {user_info?.deficit_value &&
                            user_info?.deficit_percentage ? (
                              <p className="mb-1 d-flex align-items-center justify-content-end">
                                <span className="fw-bold me-3">
                                  Total calories after deficit:&nbsp;
                                </span>
                                {applyDeficit()} kcal
                              </p>
                            ) : (
                              ""
                            )}
                            {user_info?.deficit_value &&
                            user_info?.deficit_percentage ? (
                              <p className="mb-1 text-muted w-100">
                                Your calorie deficit is active at{" "}
                                {user_info?.deficit_value}%, and your food
                                portions have been adjusted accordingly.
                              </p>
                            ) : (
                              ""
                            )}
                            {mealsData.map((meal, mealindex) => {
                              return (
                                <div
                                  className="col-12 col-md-6 mb-3"
                                  key={mealindex}
                                >
                                  <div className="card meals_card p-2">
                                    <h4 className="primary_color fw-bold mb-2 text-center">
                                      {meal.meal_name}
                                    </h4>
                                    {meal?.meal_food_array &&
                                      meal?.meal_food_array?.length > 0 && (
                                        <div className="col-12">
                                          <table className="table table-sm table-bordered">
                                            <thead>
                                              <tr>
                                                <th>Food</th>
                                                <th>Type</th>
                                                <th>Quantity</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {meal?.meal_food_array?.map(
                                                (units, index) => (
                                                  <tr key={index}>
                                                    <td>
                                                      {
                                                        units?.selected_food
                                                          ?.name
                                                      }
                                                    </td>
                                                    <td>
                                                      {units?.selected_food
                                                        ?.measurement_units &&
                                                      units?.selected_food
                                                        ?.measurement_units
                                                        .length > 0
                                                        ? `${units?.measurement_units?.measurement_unit_name}`
                                                        : ""}
                                                    </td>
                                                    <td
                                                      className={`${
                                                        user_info?.deficit_percentage
                                                          ? "text_warning"
                                                          : ""
                                                      }`}
                                                    >
                                                      {getQuantityPercentage(
                                                        units?.quantity,
                                                      )}
                                                      g
                                                    </td>
                                                  </tr>
                                                ),
                                              )}
                                            </tbody>
                                          </table>
                                          {meal?.meal_food_array_alt.length >
                                            0 && (
                                            <>
                                              <p
                                                style={{
                                                  color:
                                                    "var(--portal-main-color)",
                                                }}
                                                className="text-center"
                                              >
                                                Alternative Meal
                                              </p>
                                              <table className="table table-sm table-bordered">
                                                <thead>
                                                  <tr>
                                                    <th>Food</th>
                                                    <th>Type</th>
                                                    <th>Quantity</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {meal?.meal_food_array_alt.map(
                                                    (units, index) => (
                                                      <tr key={index}>
                                                        <td>
                                                          {
                                                            units?.selected_food
                                                              ?.name
                                                          }
                                                        </td>
                                                        <td>
                                                          {units?.selected_food
                                                            ?.measurement_units &&
                                                          units?.selected_food
                                                            ?.measurement_units
                                                            .length > 0
                                                            ? `${units?.measurement_units?.measurement_unit_name}`
                                                            : ""}
                                                        </td>
                                                        <td
                                                          className={`${
                                                            user_info?.deficit_percentage
                                                              ? "text_warning"
                                                              : ""
                                                          }`}
                                                        >
                                                          {getQuantityPercentage(
                                                            units?.quantity,
                                                          )}
                                                          g
                                                        </td>
                                                      </tr>
                                                    ),
                                                  )}
                                                </tbody>
                                              </table>
                                            </>
                                          )}
                                        </div>
                                      )}
                                  </div>
                                </div>
                              );
                            })}
                          </>
                        )}
                      </>
                    )}
                </div>

                {addArray[mainindex]?.description && (
                  <DescriptionSeeMore
                    description={addArray[mainindex]?.description}
                  />
                )}
                <div className="d-flex justify-content-end mt-3">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{ p: "3px" }}
                          checked={
                            addArray[mainindex]?.is_completed
                              ? addArray[mainindex]?.is_completed
                              : false
                          }
                          onChange={(e) => handleChangeComplete(e, mainindex)}
                        />
                      }
                      label="Mark as Complete"
                    />
                  </FormGroup>
                </div>
              </Box>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default FoodMattersAndMindsetUI;
